<template>
  <div style="overflow-x: none !important">
    <div class="sub-banner">
      <div class="nav-menu">
        <component :is="sosmed.img" width="25" height="25" alt="" @click="toSosmed(sosmed.link)"
          v-for="(sosmed, index) in soscialMedia" :key="index" style="cursor: pointer" />
      </div>
      <h1 class="title-banner" v-html="$t('home.heroSection.title')"></h1>
      <p class="sub-title-banner" style="max-width: 1000px; width: 100%; margin: auto; font-weight: 300"
        v-html="$t('home.heroSection.subtitle')"></p>
      <div class="menu-flex">
        <!-- <div class="ctn" @click="goToClass">
          <PublicIc />
          <span style="margin-top: 10px">Public Training</span>
        </div> -->
        <!-- <div class="ctn" @click="goToBootcamp">
          <BootcampIc />
          <span style="margin-top: 10px">Bootcamp</span>
        </div>
        <div class="ctn" @click="goToCertification">
          <PraIc />
          <span style="margin-top: 10px">Certification</span>
        </div>
        <div class="ctn" @click="goToEvent">
          <EventIc />
          <span style="margin-top: 10px">Event</span>
        </div>
        <div class="ctn" @click="goToCorporateTraining">
          <CorpIc />
          <span style="margin-top: 10px">For Corporate</span>
        </div> -->
      </div>
    </div>
    <div class="container-fade">
      <div class="left-fade"></div>
      <div class="right-fade"></div>
    </div>
    <div class="logo">
      <div class="card-container">
        <div class="card">
          <div v-for="(partner, index) in partners" :key="index">
            <div class="logo-card-partner-2">
              <img :src="partner.img_url_web" width="160" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="key-feature container">
      <div class="card-feature">
        <div class="content">
          <h2 style="line-height: 38px;">{{ $t('home.aboutSection.title') }}</h2>
          <p style="margin-top: -15px;">{{ $t('home.aboutSection.description') }}</p>
          <div class="list">
            <div>
              <h2>1500+</h2>
              <p>{{ $t('home.additionalInfo.0.title') }}</p>
            </div>
            <div>
              <h2>20+</h2>
              <p>{{ $t('home.additionalInfo.1.title') }}</p>
            </div>
            <div>
              <h2>16+</h2>
              <p>{{ $t('home.additionalInfo.2.title') }}</p>
            </div>
            <div>
              <h2>4.8</h2>
              <p>Google Rating</p>
            </div>
          </div>
        </div>
        <iframe class="card-image" style="width: 500px; height: 300px"
          src="https://www.youtube.com/embed/7mBp0DYzql4?si=O6Aw9SheRYdJm3a2" title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
    <div class="unique-selling-proposition">
      <h1 class="text-center poppins-font usp-title">
        {{ $t('home.uspSection.title') }}
        <div class="content">
          <div class="row">
            <div class="col-lg-4 items" v-for="(item, idx) in $t('home.usps')" :key="idx">
              <div class="card text-start" style="background-color: white">
                <img :src="item.img" alt="" width="60" height="60" />
                <div class="label">
                  <p class="sub-title">{{ item.name }}</p>
                  <p class="description">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </h1>
    </div>
    <div class="usp" style="margin-top: 80px">
      <div class="card-usp">
        <div class="card-img">
          <img src="/img/corporate/collaboration/training.png" alt="" />
        </div>
      </div>
      <div class="usp-container" style="position: relative">
        <h2>{{ $t('home.usp2Section.title') }}</h2>
        <div class="card-usp" v-for="(usp, index) in $t('home.usps2')" :key="index">
          <div class="title-container mb-2">
            <div style="width: 30px; height: 30px">
              <component :is="usp.image"></component>
            </div>
            <div>
              <h3>{{ usp.title }}</h3>
              <p>{{ usp.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Banner :partners="banners" />
    <div class="list-of-acceleration">
      <div class="container">
        <h1 class="text-center my-1">{{ $t('home.accelerationProgramSection.title') }}</h1>
        <div class="nav-container">
          <button v-for="(tab, index) in tabs" :key="index" :class="{ 'active': activeTab === tab }"
            @click="setActiveTab(tab)">
            {{ tab }}
          </button>
        </div>
        <div class="card" style="padding-bottom: 60px">
          <div class="items" v-for="(item, idx) in listClass" :key="idx" @click="directDetail(item.slug_name)"
            :title="item.name">
            <div style="height: 160px">
              <img :src="item.image_url" alt="" style="width: 100%; height: 100%; border-radius: 20px 20px 0 0" />
              <div class="label" v-if="item.collaboration_feed">
                <img :src="item.collaboration_feed" alt="" style="width: 80%" />
              </div>
            </div>
            <div class="content">
              <div style="height: 45px;">
                <h2>{{ item.name }}</h2>
              </div>
              <div class="category">
                <div style="background-color: #f1f6ff" v-if="item.level">
                  <p>{{ item.level }}</p>
                </div>
              </div>
              <div class="event-ctn-info my-2" v-if="item.session">
                <NoteIcon :width="25" fill="#575966" />
                <span class="name">{{ item.session }} {{ $t('home.a2') }}</span>
              </div>
              <div class="event-ctn-info my-2" v-if="activeTab != 'Event'">
                <AwardIcon :width="25" fill="#575966" />
                <span class="name">Reguler / Private</span>
              </div>
              <div class="event-ctn-info" v-if="item.days">
                <DateIcon :width="22" fill="#575966" />
                <span class="name">{{ item.days }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.hours">
                <Clock :width="22" fill="#575966" />
                <span class="name">{{ item.hours }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.method">
                <Methode :width="22" fill="#575966" />
                <span class="name">{{ item.method | toMethode }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-stoke-blue" style="background-color: white;" @click="directOther">
          <span class="font-poppins">{{ $t('home.a1') }}</span>
          <ArrowLong />
        </div>
      </div>
    </div>
    <div class="list-of-acceleration" style="background-color: white;">
      <div class="container">
        <div style="display: flex; gap: 70px; ">
          <div style="max-width: 65%;">
            <div class="card-box">
              <div class="card-1" v-for="(item, idx) in $t('home.descs1')" :key="idx">
                <img :src="item.img" class="img-2" />
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </div>
          <div style="max-width: 35%;">
            <p class="margin-0">{{ $t('home.accelerationPrograms.corporateServiceSection.title') }}</p>
            <h1 class="margin-0" style="line-height: 35px;">{{
              $t('home.accelerationPrograms.corporateServiceSection.subtitle') }}</h1>
            <p class="mt-4">{{ $t('home.accelerationPrograms.corporateServiceSection.description') }}</p>
            <div class="btn-blue" @click="$router.push('/corporate')" style="margin: 20px 0 0 0;">
              <span class="font-poppins">{{ $t('home.a1') }}</span>
              <ArrowLong fill="white" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-of-acceleration">
      <div class="container">
        <div style="display: flex; gap: 30px; ">
          <div style="max-width: 40%;">
            <p class="margin-0">{{ $t('home.accelerationPrograms.testimonySection.title') }}</p>
            <h1 class="margin-0" style="line-height: 35px;">{{ $t('home.accelerationPrograms.testimonySection.subtitle')
            }}</h1>
            <div class="btn-stoke-blue" style="margin: 20px 0 0 0;" @click="$router.push('/testimony')">
              <span class="font-poppins">{{ $t('home.a1') }}</span>
              <ArrowLong />
            </div>
          </div>
          <div style="width: 60%;" class="masonry">
            <div class="card-2" v-for="(item, idx) in testimonies" :key="idx">
              <p class="text-center">{{ item.feedback }}</p>
              <div class="profile mt-5 d-flex" style="align-items: center">
                <div class="avatar">
                  <v-img :src="$utils.loadImage(item.image_url)" alt="" width="60" height="60" class="avatar-image" />
                </div>
                <div class="testi-profile ml-5">
                  <div class="name">{{ item.name }}</div>
                  <div class="description">
                    {{ item.job }} {{ item.place }}
                  </div>
                  <v-img v-if="item.linkedin" src="/img/home/linkedin.png" alt="" width="23" height="23"
                    @click="redirectReload(item.linkedin)" class="linkedin-image cursor-pointer" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="faq" style="margin-top: 60px;">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header" style="margin-bottom: 20px;">
              <h1>Frequently Asked Question</h1>
            </div>
          </div>
          <div class="col-lg-9" style="margin-top: -10px;">
            <v-expansion-panels flat class="faq-card" style="padding: 20px;">
              <v-expansion-panel v-for="(item, index) in questions" :key="index"
                style="border-radius: 20px; padding: 0; margin-bottom: 10px; border: 1px solid #D3D6E1;">
                <v-expansion-panel-header disable-icon-rotate @click="openFaq(index)">
                  <h2 style="margin: 25px 0; font-size: 18px;">{{ item.title }}</h2>
                  <template v-slot:actions>
                    <div class="icon" v-if="item.active">
                      <Arrow />
                    </div>
                    <div v-else>
                      <Arrow :down="!item.active" />
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.description"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div style="padding: 25px 30px;">
              <div class="btn-stoke-blue cursor-pointer" @click="$router.push('/faq')"
                style="margin: 0;background-color: white">
                <span class="font-poppins">{{ $t('home.a1') }}</span>
                <ArrowLong />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goTo from 'vuetify/lib/services/goto';
import Banner from '../Banner.vue';
import Arrow from '@/assets/icons/Arrow.vue';
import DateIc2 from '../icons/Date.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import Event from '../Event.vue';
import Prakerja from '../Prakerja.vue';
import BootcampIc from '../icons/BootcampIc.vue';
import PublicIc from '../icons/Public.vue';
import CorpIc from '../icons/CorpIc.vue';
import PraIc from '../icons/PraIc.vue';
import EventIc from '../icons/Event.vue';
import Instagram from '@/assets/icons/sosmed/Instagram.vue';
import Facebook from '@/assets/icons/sosmed/Facebook.vue';
import Linkedin from '@/assets/icons/sosmed/Linkedin.vue';
import Tiktok from '@/assets/icons/sosmed/Tiktok.vue';
import Youtube from '@/assets/icons/sosmed/Youtube.vue';
import Heart from '../icons/Heart.vue';
import Skill from '../icons/Skill.vue';
import Lamp from '../icons/Lamp.vue';
import DateIcon from '../icons/Date.vue';
import Clock from '../icons/Clock.vue';
import Methode from '../icons/Methode.vue';
import NoteIcon from '@/assets/icons/Note.vue';
import AwardIcon from '@/assets/icons/Award.vue';

export default {
  components: {
    NoteIcon,
    AwardIcon,
    DateIcon,
    Clock,
    Methode,
    Instagram,
    Facebook,
    Linkedin,
    Tiktok,
    Youtube,
    BootcampIc,
    PublicIc,
    CorpIc,
    PraIc,
    EventIc,
    DateIc2,
    Banner,
    Prakerja,
    Event,
    Arrow,
    ArrowLong,
    Heart,
    Skill,
    Lamp,
  },
  data() {
    return {
      dialog: true,
      mobileView: false,
      notifActive: true,
      is_login_show: false,
      partners: [],
      bootcampClass: [],
      prakerjaClass: [],
      recommendationClass: [],
      banners: [],
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      soscialMedia: [
        {
          name: 'instagram',
          img: Instagram,
          link: 'https://instagram.com/hicolleagues',
        },
        {
          name: 'facebook',
          img: Facebook,
          link: 'https://www.facebook.com/hicolleagues/',
        },
        {
          name: 'linkedin',
          img: Linkedin,
          link: 'https://www.linkedin.com/company/hicolleagues?originalSubdomain=id',
        },
        {
          name: 'tiktok',
          img: Tiktok,
          link: 'https://www.tiktok.com/@hicolleagues',
        },
        {
          name: 'youtube',
          img: Youtube,
          link: 'https://www.youtube.com/@HiColleagues',
        },
      ],
      testimonies: [],
      accelerations: [],
      listClass: [],
      questions: [],
      events: [],
      tabs: ['Public Training', 'Bootcamp', 'Certification', 'Event'],
      activeTab: 'Public Training',
    };
  },
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;
    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return goTo(scrollTo);
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
  },
  watch: {
    '$i18n.locale'() {
      this.setActiveTab(this.activeTab);
      this.getFaq();
      this.getTestimoni();
    },
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
      this.$gtag.event('click', {
        event_category: 'Tab',
        event_label: `Tab - ${tab}`,
        value: 1,
      });
      if (tab === 'Public Training') {
        this.getPublicClass();
      } else if (tab === 'Bootcamp') {
        this.getBootcampClass();
      } else if (tab === 'Certification') {
        this.getAccelerationClass();
      } else if (tab === 'Prakerja') {
        this.getPrakerjaClass();
      } else {
        this.getDataEvents();
      }
    },
    directDetail(slugName) {
      const item = this.listClass.find(item => item.slug_name === slugName);
      if (item) {
        this.$gtag.event('view_item', {
          event_category: 'E-commerce',
          event_label: item.name,
          value: item.price || 0,
          items: [
            {
              item_id: item.slug_name,
              item_name: item.name,
              item_category: this.activeTab,
              price: item.price || 0,
              quantity: 1,
            },
          ],
        });
      }
      if (this.activeTab === 'Public Training') {
        this.$router.push(`/class/public-training/detail/${slugName}`);
      } else if (this.activeTab === 'Bootcamp') {
        this.$router.push(`/class/bootcamp/${slugName}`);
      } else if (this.activeTab === 'Certification') {
        this.$router.push(`/certification/detail/${slugName}`);
      } else if (this.activeTab === 'Prakerja') {
        this.$router.push(`/class/prakerja/${slugName}`);
      } else {
        this.$router.push(`/event/detail/${slugName}`);
      }
    },
    directOther() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `${this.activeTab} See More Button`,
        value: 1,
      });
      if (this.activeTab === 'Public Training') {
        this.$router.push('/class/public-training');
      } else if (this.activeTab === 'Bootcamp') {
        this.$router.push('/class/bootcamp');
      } else if (this.activeTab === 'Certification') {
        this.$router.push('/certification');
      } else if (this.activeTab === 'Prakerja') {
        this.$router.push('/prakerja');
      } else {
        this.$router.push('/event');
      }
    },
    redirectReload(e) {
      if (e.slice(0, 5) === 'https') {
        this.$gtag.event('click', {
          event_category: 'Social Media',
          event_label: `LinkedIn Testimony - ${e}`,
          value: 1,
        });
        window.open(e, '_blank');
      } else {
        this.$router.push({ path: e }).then(() => {
          this.$router.go();
        });
      }
    },
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === 'online') {
        return 'Daring';
      } else if (value.toLowerCase() === 'offline') {
        return 'Luring';
      } else {
        return value;
      }
    },
    toDiscount(item) {
      const total_price = item.price - item.discount;
      if (total_price <= 0) {
        return 'FREE';
      } else {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return formatter.format(total_price);
      }
    },
    openFaq(idx) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `FAQ - ${this.questions[idx].title}`,
        value: 1,
      });
      const valDef = this.questions[idx].active;
      this.questions.forEach(e => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=HOME&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    toSosmed(link) {
      this.$gtag.event('click', {
        event_category: 'Social Media',
        event_label: `Social Media - ${link}`,
        value: 1,
      });
      window.open(link);
    },
    goToCustomerService() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Customer Service WhatsApp',
        value: 1,
      });
      window.location.href = 'https://api.whatsapp.com/send/?phone=6282127274632&text=Hi Kak HiColleagues, saya mau bertanya';
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(`/v1/testimony?category=HOME&is_active=true&page=1&per_page=4`);
        this.testimonies = resp.data.data.testimonies;
      } catch (err) {
        console.log(err);
      }
    },
    async getBanners() {
      await this.$http
        .get('/v1/banner?category=GENERAL&is_active=true')
        .then((response) => {
          this.banners = response.data.data.banners;
        })
        .catch((err) => console.error(err.response));
    },
    async getDataEvents() {
      try {
        const resp = await this.$http.get(`/v1/event?is_active=true`);
        this.listClass = resp.data.data.events.map((item) => ({
          ...item,
          image_url: item.img_urls.desktop.thumbnail,
          session: item.total_session,
          days: '',
          hours: `${item.session_schedules[0].start_time} - ${item.session_schedules[0].end_time} WIB`,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    async getBootcampClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/5?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getPrakerjaClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/4?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getPublicClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/1?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getAccelerationClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/6?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get('/v1/logo?category=CORPORATE');
        this.partners = resp.data.data.logos;
        this.partners = [...this.partners, ...this.partners, ...this.partners, ...this.partners];
      } catch (err) {
        console.log(err);
      }
    },
    goToHomePage() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Home Page',
        value: 1,
      });
      this.$router.push({ path: '/' }).then(() => {
        this.$router.go();
      });
    },
    goToLoginPage() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Login Page',
        value: 1,
      });
      this.$router.push({ path: '/login' }).then(() => {
        this.$router.go();
      });
    },
    goToClassBootcamp(slug_name) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Class Bootcamp - ${slug_name}`,
        value: 1,
      });
      this.$router.push('/class/public-training/detail/' + slug_name);
      sessionStorage.setItem('nav-item-active', 0);
      window.location.reload();
    },
    goToRouter(link) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Router - ${link}`,
        value: 1,
      });
      this.$router.push({ path: link }).then(() => {
        this.$router.go();
      });
    },
    goToClass() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Public Training Button',
        value: 1,
      });
      this.$router.push({ path: '/class/public-training' }).then(() => {
        this.$router.go();
      });
    },
    goToEvent() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Event Button',
        value: 1,
      });
      this.$router.push({ path: '/event' }).then(() => {
        this.$router.go();
      });
    },
    goToCertification() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Certification Button',
        value: 1,
      });
      this.$router.push({ path: '/certification' }).then(() => {
        this.$router.go();
      });
    },
    goToCorporateTraining() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Corporate Training Button',
        value: 1,
      });
      this.$router.push({ path: '/corporate/training' }).then(() => {
        this.$router.go();
      });
    },
    goToBootcamp() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Bootcamp Button',
        value: 1,
      });
      this.$router.push({ path: '/class/bootcamp' }).then(() => {
        this.$router.go();
      });
    },
    minimize(text) {
      return text.length > 290 ? text.slice(0, 290) + '...' : text;
    },
    goToTalentAsAService() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Talent as a Service',
        value: 1,
      });
      this.$router.push({ path: '/talent-service' }).then(() => {
        this.$router.go();
      });
    },
    async toCheckout(data) {
      this.isLoading = true;
      try {
        const response = await this.$http.get(`/v1/class-detail/${data.slug_name}`);
        const classDetail = response.data.data.class_detail;

        this.$gtag.event('add_to_cart', {
          event_category: 'E-commerce',
          event_label: classDetail.name,
          value: classDetail.price || 0,
          items: [
            {
              item_id: classDetail.class_id,
              item_name: classDetail.name,
              item_category: classDetail.category_id,
              price: classDetail.price || 0,
              quantity: 1,
            },
          ],
        });

        const reqCheckout = JSON.stringify({
          class_id: classDetail.class_id,
          class_name: classDetail.name,
          price: classDetail.price,
          level: classDetail.level,
          session: classDetail.session_total,
          hour: classDetail.hours,
          image_url: classDetail.small_image_url,
          class_type: 'PRAKERJA_CLASS',
          days: classDetail.days,
          methode: classDetail.method,
          category_id: classDetail.category_id,
        });

        localStorage.clear();
        localStorage.setItem('checkout', reqCheckout);
        this.isLoading = false;
        window.location.href = '/checkout';
      } catch (err) {
        this.isLoading = false;
        console.error(err.response);
      }
    },
  },
  mounted() {
    this.getBanners();
    this.getPublicClass();
    this.getClientLogo();
    this.getFaq();
    this.getTestimoni();
  },
};
</script>

<style src="./home.css" scoped></style>